import { apiClient } from './client';
import { parseQuestionDifficulty } from './question-difficulty-contract';

export const questionDifficultyApi = {
  async get(id: string) {
    return parseQuestionDifficulty(await apiClient.questions.getById(id), id);
  },
};
